import React from 'react';

interface PolygonsIconProps {
  style?: React.CSSProperties;
}

const PolygonsIcon: React.FC<PolygonsIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Polygon Annotation</title>
      <g clipPath="url(#clip0)">
        <path d="M25.98 22.5L12.99 30 0 22.5v-15L12.99 0l12.99 7.5v15z" fill="#6A11EA" />
        <path
          d="M25.98 18.75l-9.741 5.625-9.744-5.625V7.5l9.744-5.625L25.98 7.5v11.25z"
          fill="#943CFF"
        />
        <path d="M25.98 15l-6.495 3.75L12.99 15V7.5l6.495-3.75L25.98 7.5V15z" fill="#DD45D3" />
        <path
          d="M25.98 11.25l-3.249 1.875-3.246-1.875V7.5l3.249-1.875L25.98 7.5v3.75z"
          fill="#FD9D52"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h25.98v30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PolygonsIcon;
